import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';

export default function internalUsersReducer(state = initialState.internalUsers, action) {
	switch (action.type) {
		case types.GET_INTERNAL_USERS: {
			let newState = {};
			if (action.response && action.response.users) {
				newState = Utility.normalize(action.response.users, undefined, 'gui');
			}
			return newState;
		}
		default:
			return state;
	}
}
